import axios from '../../plugins/axios'
import fileDownload from 'js-file-download'
import moment from 'moment-timezone'

export const listDelivery = ({ commit }, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` },
    params: payload ? payload.params : null
  }
  return axios.get('/delivery', config)
    .then(response => {
      commit('SET_DELIVERIES', { deliveries: response.data.deliveries })
      return response
    })
    .catch(err => err.response)
}

export const listDriverDelivery = ({ commit }, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` },
    params: payload ? payload.params : null
  }
  if (!payload.append) {
    commit('SET_LOADING', false)
    commit('SET_LOAD_DRIVER_ROUTES', true)
  }
  return axios.get(`/driver/${payload.driverId}/delivery`, config)
    .then(response => {
      const deliveries = response.data.deliveries || []
      if (payload.append) {
        commit('APPEND_DELIVERIES', { deliveries })
      } else {
        commit('SET_DELIVERIES', { deliveries })
      }
      const finalRoute = [...deliveries].filter((d) => d.order === -1000)
      if (finalRoute.length > 0) commit('SET_FINAL_ROUTE', { finalRoute: finalRoute[0] })
      if (!payload.append) {
        commit('SET_LOADING', true)
        commit('SET_LOAD_DRIVER_ROUTES', false)
      }
      return response
    })
    .catch(err => err.response)
}

export const getDelivery = ({ commit }, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  commit('SET_DELIVERY', { delivery: null })
  return axios.get(`/delivery/${payload.id}`, config)
    .then((response) => {
      commit('SET_DELIVERY', { delivery: response.data })
      return response
    })
    .catch(err => err.response)
}

export const bulkCreateDelivery = (_, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.post('/bulk_delivery', payload.data, config)
    .then(response => response)
    .catch(err => err.response)
}

export const createDelivery = (_, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.post('/delivery', payload.data, config)
    .then(response => response)
    .catch(err => err.response)
}

export const deleteDelivery = (_, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.delete(`/delivery/${payload.id}`, config)
    .then(response => response)
    .catch(err => err.response)
}

export const updateDelivery = (_, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.put(`/delivery/${payload.id}`, payload.data, config)
    .then(response => response)
    .catch(err => err.response)
}

export const createDeliveryImage = (_, { data, deliveryId }) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' } }

  return axios.post(`/delivery-image/${deliveryId}/image`, data, config)
}

export const updateDriverDeliveryOrder = (_, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.put(`/driver/${payload.driverId}/delivery-bulk-order`, payload.data, config)
    .then(response => response)
    .catch(err => err.response)
}

export const bulkUpdateDeliveryDriver = (_, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.put('/bulk-delivery-change-driver', payload.data, config)
    .then(response => response)
    .catch(err => err.response)
}

export const driverBulkReassignDeliveries = (_, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.put('/driver/bulk-reassign', payload.data, config)
    .then(response => response)
    .catch(err => err.response)
}

export const changeDeliveryStateMasive = (_, payload) => {
  return axios.put('/delivery/change-state-masive', payload)
}

export const getDeliveriesByIds = (_, params) => {
  return axios.get('/delivery/deliveries-by-ids', { params })
}

export const bulkDeleteDelivery = (_, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` }, data: payload.data }
  return axios.delete('/bulk-delete-delivery', config)
    .then(response => response)
    .catch(err => err.response)
}

export const bulkUpdateDelivery = (_, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.put('/bulk-update-delivery', payload.data, config)
    .then(response => response)
    .catch(err => err.response)
}

export const bulkUpdateDeliveryDate = (_, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.put('/bulk-delivery-update-date', payload.data, config)
    .then(response => response)
    .catch(err => err.response)
}

export const getCountStates = ({ commit }, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` },
    params: payload ? payload.params : null
  }
  return axios.get('/delivery-state-count', config)
    .then(response => {
      commit('SET_COUNT_STATES', { countStates: response.data })
      return response
    })
    .catch(err => err.response)
}

export const createFinalRoute = (_, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.post(`/driver/${payload.driverId}/create_final_route`, payload.data, config)
    .then(response => response)
    .catch(err => err.response)
}

export const getGeocode = async (_, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  const data = { address: payload }
  const response = await axios.post('/delivery-get-geocode', data, config)
  console.log(response)
  return response
}

export const getAutocomplete = ({ commit }, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` },
    params: payload ? payload.params : null
  }
  return axios.get('/delivery-get-autocomplete', config)
    .then(response => {
      commit('SET_AUTOCOMPLETE_ADDRESSESS', response.data)
    })
    .catch(err => err.response)
}

export const downloadExcelDelivery = (_, { params } = {}) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` },
    params: params
  }
  return axios.get('/delivery-excel', { ...config, responseType: 'blob' })
    .then(response => {
      const currentDate = moment.tz('America/Santiago')
      const hours = currentDate.hours()
      const minutes = currentDate.minutes()
      const date = moment().format('DD-MM-YYYY')
      fileDownload(response.data, `${date}_${hours}:${minutes}_Envios.xlsx`)
      return response
    })
    .catch(err => err.response)
}

export const downloadStoreExcelDelivery = (_, { params } = {}) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` },
    params: params
  }
  return axios.get('/delivery-excel/store', { ...config, responseType: 'blob' })
    .then(response => {
      const currentDate = moment.tz('America/Santiago')
      const hours = currentDate.hours()
      const minutes = currentDate.minutes()
      const date = moment().format('DD-MM-YYYY')
      fileDownload(response.data, `${date}_${hours}:${minutes}_Envios.xlsx`)
      return response
    })
    .catch(async err => {
      // Con responseType 'blob' el body de error también llega como Blob: se parsea a JSON
      // para poder mostrar el mensaje del backend (ej. rango de fechas inválido).
      const response = err.response
      if (response && response.data instanceof Blob) {
        try {
          response.data = JSON.parse(await response.data.text())
        } catch (e) {
          response.data = { message: 'No se pudo descargar el Excel' }
        }
      }
      return response
    })
}

export const getDriverReport = async (_, { params } = {}) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` },
    params: params
  }
  return axios.get('/delivery-driver-report', { ...config, responseType: 'blob' })
    .then(response => {
      fileDownload(response.data, `Reporte_conductores_${params.date}.xlsx`)
      return response
    })
    .catch(err => err.response)
}

export const checkUniqueExternalId = (_, payload) => {
  return axios.post('/delivery/check-unique-external-id', payload.data)
}

export const checkUniqueExternalIdMultiple = (_, payload) => {
  return axios.post('/delivery/check-unique-external-id-multiple', payload.data)
}

export const massiveSetPartner = (_, payload) => {
  return axios.put('/delivery/bulk-delivery-set-partner', payload.data)
}

export const validateDeliveriesIds = (_, payload) => {
  return axios.post('/delivery/validate-ids', payload)
}

export const bulkSyncPartnerStatus = (_, payload) => {
  return axios.post('/delivery/bulk-sync-partner-status', payload.data)
}

export const countPartnerErrorDeliveries = ({ commit }, payload = {}) => {
  return axios.get('/delivery/count-partner-error-deliveries', { params: payload.params })
    .then(response => {
      commit('SET_PARTNER_ERROR_COUNT', response.data.count)
      return response
    })
    .catch(err => err.response)
}

export const bulkExecuteWebhookChangeState = ({ commit }, payload = {}) => {
  return axios.post('/delivery/bulk-execute-webhook-change-state', payload)
    .catch(err => err.response)
}

/**
 * Marca un delivery como recogido en tienda.
 *
 * Body según el modo:
 *   - qr:     { qrContent: string, mode: 'qr' }
 *   - manual: { id: number, mode: 'manual' }
 *
 * Devuelve la respuesta cruda de axios. NO normaliza errores: el caller
 * (Navbar / ListDelivery) los maneja con axios.isAxiosError para mostrar
 * el message del backend.
 */
export const scanDelivery = (_, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.post('/delivery/scan', payload, config)
}

export const bulkSetPartnerByIds = (_, payload) => {
  return axios.put('/delivery/bulk-set-partner-by-ids', payload.data)
}

/**
 * spec 003: devuelve los datos exactos de N etiquetas para imprimir con
 * `ShippingLabel.vue`. Usado desde `ListDelivery.vue` y `ListStoreDelivery.vue`
 * en los 3 puntos de entrada: botón individual, "Imprimir Seleccionados",
 * "Impresión Masiva Por Fecha".
 *
 * Payload: { ids: number[] }
 * Devuelve la promesa cruda (response.data = array de labels).
 */
export const getLabelsByIds = (_, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  const ids = (payload.ids || []).join(',')
  return axios.get(`/delivery/labels-by-ids?ids=${ids}`, config)
}